import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapePentagon extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 3) / 5 - 2 * horizontalPadding;
        const allowedHeight = (height * 8) / 10 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, (height * 3) / 10, verticalPadding);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + (height * 4) / 10);
        canv.ctx.lineTo(x + (width * 2) / 10, y + height);
        canv.ctx.lineTo(x + (width * 8) / 10, y + height);
        canv.ctx.lineTo(x + width, y + (height * 4) / 10);
        canv.ctx.lineTo(x + width / 2, y);
        canv.ctx.lineTo(x, y + (height * 4) / 10);
    }

    clipAriaCoordinateY(y: number, h: number) {
        return y + (h * 5) / 4 / 2;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M10.0794 1.60046L1.6092 8.659C0.642558 9.46453 0.28132 10.7877 0.704527 11.9727L4.28893 22.009C4.71535 23.203 5.84632 24 7.11416 24H16.8858C18.1537 24 19.2846 23.203 19.7111 22.009L23.2955 11.9727C23.7187 10.7877 23.3574 9.46454 22.3908 8.659L13.9206 1.60046C12.808 0.673346 11.192 0.673345 10.0794 1.60046Z"/>
            </svg>
        `;
    }
}
